/**
 * Set up routing for all UserModule views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import userModule views
import CreateUserModule from './views/CreateUserModule.js.jsx';
import UserModuleList from './views/UserModuleList.js.jsx';
import SingleUserModule from './views/SingleUserModule.js.jsx';
import UpdateUserModule from './views/UpdateUserModule.js.jsx';

class UserModuleRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route exact path="/user-modules" component={UserModuleList} />
        <YTRoute login={true} exact path="/user-modules/new" component={CreateUserModule} />
        <Route exact path="/user-modules/:userModuleId" component={SingleUserModule}/>
        <YTRoute login={true} exact path="/user-modules/:userModuleId/update" component={UpdateUserModule}/>
      </Switch>
    )
  }
}

export default UserModuleRouter;



// WEBPACK FOOTER //
// modules/userModule/UserModuleRouter.js.jsx